import {
  WordElementCleaner,
  ParagraphCleaner,
  WhitespaceCleaner,
} from './HtmlSanitizer';
import {
  BulletListConverter,
  NumberedListConverter,
} from './HtmlListConverter';
import { CMSTableConverter } from './CMSTableConverter';

/**
 * Main Word content cleaner that orchestrates all cleaning operations
 * Follows the same workflow as the original cleanWordHtml function
 */
export class WordCleaner {
  constructor() {
    this.elementCleaner = new WordElementCleaner();
    this.paragraphCleaner = new ParagraphCleaner();
    this.whitespaceCleaner = new WhitespaceCleaner();
    this.bulletConverter = new BulletListConverter();
    this.numberedConverter = new NumberedListConverter();
    this.cmsTableConverter = new CMSTableConverter();
  }

  clean(html) {
    if (!html || typeof html !== 'string') {
      return html;
    }

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;

    // Step 1: Remove Word-specific elements and attributes
    try {
      this.elementCleaner.clean(tempDiv);
    } catch (error) {
      // Silent error handling
    }

    // Step 2: Clean empty paragraphs
    try {
      this.paragraphCleaner.clean(tempDiv);
    } catch (error) {
      // Silent error handling
    }

    // Step 3: Convert hyphen lists to HTML lists
    try {
      this.bulletConverter.convertHyphenListsToHtml(tempDiv);
    } catch (error) {
      // Silent error handling
    }

    // Step 3.5: Convert numbered lists to HTML lists
    try {
      this.numberedConverter.convertNumberedListsToHtml(tempDiv);
    } catch (error) {
      // Silent error handling
    }

    // Step 4: Remove excessive whitespace and formatting
    try {
      this.whitespaceCleaner.clean(tempDiv);
    } catch (error) {
      // Silent error handling
    }

    // Step 5: Convert Slate tables to full CMS format
    try {
      this.cmsTableConverter.convertSlateTableToCMSFormat(tempDiv);
    } catch (error) {
      // Silent error handling
    }

    return tempDiv.innerHTML;
  }
}
